import React, { useState } from 'react'
import styled from '@emotion/styled'
import type { KambiEvent, KambiHistoryCoupon, KambiLiveData } from '@mobi/api-types/kambi'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { Card } from '@mobi/component-library/Base/Card'
import { colors, radius, spacing } from '@mobi/component-library/Foundations'
import { TeamIconProvider } from '@mobi/sports-offering/Components/Common/TeamsIcon/Components/TeamIcon/TeamIconProvider'
import { LiveInfoSection } from '@mobi/sports-offering/Components/EventOutcomesCard/Components/LiveInfoSection/LiveInfoSection'
import { BetSummary } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/BetSummary'
import { ShareButton } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/Common/Buttons/ShareButton'
import { Details } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/Details'
import { getKambiCouponBetType } from '@core/Areas/KambiSports/Player/helpers/getKambiCouponBetType'
import { rebuildKambiHistoryCoupon } from '@core/Areas/KambiSports/Player/helpers/rebuildKambiHistoryCoupon'
import { OutcomeResult } from './Components/Common/OutcomeResult/OutcomeResult'

export const Coupon: React.FC<{
  historyCoupon: KambiHistoryCoupon
  liveEvent?: {
    event: KambiEvent
    liveData: KambiLiveData
  }
}> = ({ historyCoupon, liveEvent }) => {
  const [showConfirmButton, setShowConfirmButton] = useState<boolean>(false)
  //later ticket to fix logic when to show.
  const hasCashOut = false

  const betType = getKambiCouponBetType(historyCoupon)

  const coupon = rebuildKambiHistoryCoupon(historyCoupon)
  const expandableText = betType !== 'single' ? 'Legs & More' : undefined

  const onClickCashOut = () => {
    setShowConfirmButton(true)
  }
  const onClickConfirm = () => {
    // TODO: implement confirm handler
  }

  return (
    <Card>
      {liveEvent && (
        <LiveInfoWrapperStyled>
          <TeamIconProvider>
            <LiveInfoSection
              event={liveEvent.event}
              clock={liveEvent.liveData.matchClock}
              score={liveEvent.liveData.score}
              statistics={liveEvent.liveData.statistics}
              shouldUseDarkTheme
            />
          </TeamIconProvider>
        </LiveInfoWrapperStyled>
      )}

      <BetSummary historyCoupon={coupon} betType={betType} />
      {showConfirmButton && (
        <Button size='md' isFullWidth color='positive' isLoading={false} onClick={onClickConfirm}>
          Confirm
        </Button>
      )}
      {/* colour for the button not right  */}
      {hasCashOut && (
        <Button
          size='md'
          isFullWidth
          color='primary_destructive'
          isLoading={false}
          onClick={onClickCashOut}
        >
          <Icon name='CustomCashOut' size='2rem' color={colors.neutral[900]} /> Cash Out
        </Button>
      )}

      <BetCard.Footer
        expandableText={expandableText}
        expandableContent={<ExpandableContent historyCoupon={coupon} />}
        rightSection={<ShareButton historyCoupon={coupon} />}
      />
    </Card>
  )
}

// ===============
// Local Component
// ===============

const ExpandableContent: React.FC<{
  historyCoupon: KambiHistoryCoupon
}> = ({ historyCoupon }) => {
  const isSingleOutcome = historyCoupon.outcomes.length === 1
  return (
    <>
      {isSingleOutcome && (
        <OutcomeResult outcome={historyCoupon.outcomes[0]} attachToSelectionInfo={false} />
      )}
      <Details historyCoupon={historyCoupon} />
    </>
  )
}

// ======
// Styles
// ======

const LiveInfoWrapperStyled = styled.div({
  margin: `-${spacing.md} -${spacing.md} 0`,
  padding: `${spacing.sm} ${spacing.md}`,
  borderRadius: `${radius.lg} ${radius.lg} 0 0`,
  background: colors.lavender[750],
})
